import * as React from "react";

const Icon = (props) =>  (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22.676}
      height={23.623}
      {...props}
    >
      <path
        data-name="Path 126"
        d="M17.6 0H5.072A5.062 5.062 0 000 5.072v7.434a5.062 5.062 0 005.072 5.072h2.462a11.661 11.661 0 01-.771 4.7.988.988 0 001.392 1.222 21.994 21.994 0 006.216-5.918H17.6a5.062 5.062 0 005.072-5.072V5.072A5.078 5.078 0 0017.6 0zm-.945 12.432H6.017a1.119 1.119 0 010-2.238h10.642a1.119 1.119 0 110 2.238zm0-5.246H6.017a1.119 1.119 0 010-2.238h10.642a1.119 1.119 0 110 2.238z"
        fill="#737d84"
      />
    </svg>
  );


export default Icon;
